import React from 'react';
import { Facebook, Instagram, Mail, Phone } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          <div>
            <h3 className="text-2xl font-bold mb-4 text-orange-400">FEATS</h3>
            <p className="text-gray-400 leading-relaxed">
              Marmitas personalizadas conforme sua prescrição nutricional. Precisão, qualidade e praticidade.
            </p>
          </div>
          
          <div>
            <h4 className="text-lg font-semibold mb-4">Contato</h4>
            <div className="space-y-3">
              {/* <a href="mailto:contato@feats.app.br" className="flex items-center text-gray-400 hover:text-orange-400 transition-colors">
                <Mail className="h-5 w-5 mr-2" />
                contato@feats.app.br
              </a> */}
              <a href="tel:+556296481343" className="flex items-center text-gray-400 hover:text-orange-400 transition-colors">
                <Phone className="h-5 w-5 mr-2" />
                (62) 9648-1343
              </a>
            </div>
          </div>
          
          <div>
            <h4 className="text-lg font-semibold mb-4">Redes Sociais</h4>
            <div className="flex space-x-4">
              <a href="https://www.instagram.com/feats.nutri/" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-orange-600 transition-colors">
                <Instagram className="h-5 w-5" />
              </a>
              {/* <a href="#" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-orange-600 transition-colors">
                <Facebook className="h-5 w-5" />
              </a> */}
            </div>
          </div>
        </div>
        
        <div className="border-t border-gray-800 pt-8">
          <p className="text-gray-500 text-sm leading-relaxed">
            <strong className="text-gray-400">Importante:</strong> Não oferecemos aconselhamento nutricional nem médico. 
            A produção segue as quantidades informadas pelo cliente conforme prescrição do seu profissional de saúde.
          </p>
          <p className="text-gray-600 text-center mt-4">
            © {new Date().getFullYear()} FEATS. Todos os direitos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;